// Shared source of truth for company profiles.
// Used by companies.$companyId head() so Open Graph metadata always matches
// the specific company shown on the page.
import cover from "@/assets/company-cover.webp";
import logo from "@/assets/company-logo.webp";

export interface CompanyInfo {
  id: string;
  name: string;
  tagline: string;
  location: string;
  description: string;
  cover: string;
  logo: string;
}

export const COMPANIES: CompanyInfo[] = [
  {
    id: "1",
    name: "Loftworks Studios",
    tagline:
      "Brooklyn's curated collection of industrial lofts, photo studios and rooftop venues — bookable by the hour.",
    location: "Brooklyn, New York",
    description:
      "Browse spaces, amenities and reviews from Loftworks Studios — Brooklyn's most-loved hourly space provider on Spayzo.",
    cover,
    logo,
  },
];

export function getCompany(id: string): CompanyInfo {
  return COMPANIES.find((c) => c.id === id) ?? COMPANIES[0];
}
